import { INITIALIZE_COMPONENT, SET_ERROR, LOCALIZED_INPUT, CLEAR_ERROR } from '../types';

export const init = dispatch => component => dispatch({ type: INITIALIZE_COMPONENT, component });
export const setError = dispatch => error => dispatch({ type: SET_ERROR, payload: error });
export const setValue = dispatch => (name, value) => dispatch({ name, value });
export const setValueLocalized = dispatch => (name, value, language) => dispatch({ type: LOCALIZED_INPUT, language, name, value });
export const clearError = dispatch => (fieldName) => {
  dispatch({ type: CLEAR_ERROR, payload: fieldName });
};
